var map = {
	"./default/cake.svg": 425,
	"./default/camera.svg": 200,
	"./default/car.svg": 693,
	"./default/ceremony.svg": 641,
	"./default/champagne.svg": 705,
	"./default/cocktail.svg": 159,
	"./default/dance.svg": 30,
	"./default/dinner.svg": 177,
	"./default/music.svg": 382,
	"./default/party.svg": 459,
	"./default/rings.svg": 402,
	"./default/toast.svg": 546,
	"./hand-drawn/arch.svg": 274,
	"./hand-drawn/cake.svg": 534,
	"./hand-drawn/camera.svg": 343,
	"./hand-drawn/car.svg": 584,
	"./hand-drawn/champagne-1.svg": 562,
	"./hand-drawn/champagne-2.svg": 497,
	"./hand-drawn/church.svg": 207,
	"./hand-drawn/clothes.svg": 42,
	"./hand-drawn/doves.svg": 685,
	"./hand-drawn/flowers.svg": 774,
	"./hand-drawn/gift.svg": 636,
	"./hand-drawn/glasses.svg": 862,
	"./hand-drawn/guitar.svg": 984,
	"./hand-drawn/notes.svg": 761,
	"./hand-drawn/pizza.svg": 592,
	"./hand-drawn/plate.svg": 762,
	"./hand-drawn/rings-2.svg": 170,
	"./hand-drawn/rings.svg": 583,
	"./hand-drawn/shoes.svg": 570,
	"./hand-drawn/snacks.svg": 519,
	"./hand-drawn/wine.svg": 669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;